import {block}                     from "./block";
import {Table}                     from "./Table";
import {Header}                    from "./Header";
import {Footer}                    from "./Footer";
import                                  "./styles/index.less";


export { block, Table, Header, Footer };
